import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  emoji: '🍳',
  title: 'Desayunos',
  count: '25+ Recetas',
  description: 'Comienza tu día con energía sin sobrecargar tu hígado. Opciones rápidas y saciantes.'
}, {
  emoji: '🥗',
  title: 'Almuerzos',
  count: '35+ Recetas',
  description: 'Platos fuertes, balanceados y llenos de sabor para mantenerte satisfecho.'
}, {
  emoji: '🍎',
  title: 'Snacks',
  count: '20+ Recetas',
  description: 'Antojos saludables para calmar el hambre entre comidas sin culpa.'
}, {
  emoji: '🥣',
  title: 'Cenas',
  count: '25+ Recetas',
  description: 'Opciones ligeras y reconfortantes para un descanso reparador.'
}];
export function RecipeCategories() {
  return <section className="py-20 bg-white" data-id="element-164">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-167">
            ¿Qué encontrarás dentro del Recetario?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-168">
            Un menú completo para cada momento del día. Todo diseñado para
            nutrir, desinflamar y apoyar la regeneración de tu hígado.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-169">
          {categories.map((cat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-bg p-8 rounded-3xl text-center hover:-translate-y-2 transition-transform duration-300" data-id="element-170">
              <div className="text-5xl mb-4" data-id="element-171">{cat.emoji}</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-172">
                {cat.title}
              </h3>
              <span className="inline-block bg-brand-accent/20 text-brand-dark text-sm font-semibold px-3 py-1 rounded-full mb-4" data-id="element-173">
                {cat.count}
              </span>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-174">
                {cat.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}